import { AbstractControl, ValidatorFn } from '@angular/forms';
import { AttachmentDto } from '../common/attachment/attachment';

// export function customAttachmentValidator(): ValidatorFn {
//   return (control: AbstractControl): { [key: string]: any } | null => {
//     const attachmentList = control.value as AttachmentDto[];
//     // Check if attachmentList is an array and not null or undefined
//     if (!Array.isArray(attachmentList) || !attachmentList.length) {
//       return { requiredValidAttachment: true };
//     }

//     // Check if the list has at least one item without isDeleted = true
//     const hasValidAttachment = attachmentList.some(
//       (attachment) => attachment.isDeleted !== true
//     );

//     // If the list doesn't contain any valid attachments, return an error
//     return hasValidAttachment ? null : { requiredValidAttachment: true };
//   };
// }


export function customAttachmentValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const attachmentList = control.value as AttachmentDto[];

    // If null, undefined, or empty — it's valid (not required)
    if (!attachmentList || !Array.isArray(attachmentList) || attachmentList.length === 0) {
      return null;
    }

    // Validate attachments only if present
    const hasValidAttachment = attachmentList.some(
      (attachment) => attachment?.isDeleted !== true
    );

    return hasValidAttachment ? null : { invalidAttachments: true };
  };
}
